import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["renderAs", "children", "clientId", "omitTooltip", "tooltipPlacement"];
import { useForkRef } from "@smartsheet/lodestar-utils";
import React, { forwardRef, useMemo } from "react";
import { useOverflowTooltip } from "../../../util/useOverflowTooltip";
import { Tooltip, TooltipBody } from "../../tooltip";
import { getTypeRampV2PrecomputedComponent } from "../styled/TypeRampV2PrecomputedComponents";
var elementIsScrollable = function elementIsScrollable(elem) {
  return !!elem && (elem.offsetHeight < elem.scrollHeight || elem.offsetWidth < elem.scrollWidth);
};
export var TypeRampV2 = /*#__PURE__*/forwardRef(function (props, parentRef) {
  var renderAs = props.renderAs,
    children = props.children,
    clientId = props.clientId,
    omitTooltip = props.omitTooltip,
    _props$tooltipPlaceme = props.tooltipPlacement,
    tooltipPlacement = _props$tooltipPlaceme === void 0 ? "auto" : _props$tooltipPlaceme,
    rest = _objectWithoutProperties(props, _excluded);
  var element = renderAs ? renderAs : "span";

  // Memoizing this to ensure we won't create a new component each time.
  // withComponent returns a new component.
  // do we need the theme in here too??
  var ComponentRoot = useMemo(function () {
    var Component = getTypeRampV2PrecomputedComponent({
      system: props.system,
      variant: props.variant
      // This assertion is generally ok since the props interface will ensure these match.
    });

    return Component.withComponent(element);
  }, [element, props.variant, props.system]);
  var _useOverflowTooltip = useOverflowTooltip({
      tooltipTargetRef: parentRef,
      elementIsOverflowing: elementIsScrollable,
      isDisabled: omitTooltip,
      placement: tooltipPlacement
    }),
    showOverflowTooltip = _useOverflowTooltip.showOverflowTooltip,
    tooltipProps = _useOverflowTooltip.tooltipProps,
    targetProps = _useOverflowTooltip.targetProps,
    elementToMeasureRef = _useOverflowTooltip.elementToMeasureRef;
  var combinedRef = useForkRef(elementToMeasureRef, targetProps.ref);
  return /*#__PURE__*/React.createElement(ComponentRoot, _extends({
    "data-client-id": clientId
  }, rest, omitTooltip ? {} : targetProps, {
    ref: combinedRef
  }), children, showOverflowTooltip && !omitTooltip && /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(TooltipBody, null, children)));
});
TypeRampV2.displayName = "TypeRampV2";
//# sourceMappingURL=TypeRampV2.js.map